import { render, staticRenderFns } from "./recomendacionesShow.vue?vue&type=template&id=1acc047e&scoped=true&"
import script from "./recomendacionesShow.vue?vue&type=script&lang=js&"
export * from "./recomendacionesShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1acc047e",
  null
  
)

export default component.exports